const filenameToPromptString = filename => {
  if (!filename) return '';
  return filename
    .trim()
    .replace(/  +/g, ' ')
    .substr(0, filename.lastIndexOf('.'))
    .replace(/_/g, ' ');
  // .toLowerCase()
  // .split(' ')
  // .map(word => word.replace(word[0], word[0].toUpperCase()))
  // .join(' ');
};

export default filenameToPromptString;
